import { Component } from 'preact'
import axios from 'axios'
import ArticlesOverviewPresenter from './ArticlesOverviewPresenter'

const endpoints = {
  list: '/article/listArticlesOverview'
}

const emptyFilters = {
  category: [],
  label: [],
  author: [],
  search: []
}

const DEFAULT_PAGE = 1
const DEFAULT_PAGE_SIZE = 25
const DEFAULT_ORDER = 'lastEditedAt'
const DEFAULT_DIRECTION = 'desc'
export const DEFAULT_FILTER_CRITERIA = {
  filters: emptyFilters,
  pagination: {
    page: DEFAULT_PAGE,
    pageSize: DEFAULT_PAGE_SIZE
  },
  sort: {
    order: DEFAULT_ORDER,
    direction: DEFAULT_DIRECTION
  }
}
const FILTER_STORAGE_KEY = 'filterCriteria'

class ArticlesOverview extends Component {
  constructor () {
    super()
    this.state = {
      categories: [],
      labels: [],
      authors: [],
      articles: [],
      pagination: [],
      loading: true,
      filters: emptyFilters,
      areFiltersApplied: false,
      sort: {
        order: DEFAULT_ORDER,
        direction: DEFAULT_DIRECTION
      }
    }
    this.handleResponse = this.handleResponse.bind(this)
    this.onPageChange = this.onPageChange.bind(this)
    this.onPageSizeChange = this.onPageSizeChange.bind(this)
    this.onFilterChange = this.onFilterChange.bind(this)
    this.onClearFilterCriteria = this.onClearFilterCriteria.bind(this)
    this.onSortChange = this.onSortChange.bind(this)
  }

  componentDidMount () {
    if (!window.sessionStorage.getItem(FILTER_STORAGE_KEY)) {
      window.sessionStorage.setItem(FILTER_STORAGE_KEY, JSON.stringify(DEFAULT_FILTER_CRITERIA))
      this.fetchArticles()
    } else {
      const searchCriteria = window.sessionStorage.getItem(FILTER_STORAGE_KEY) && JSON.parse(window.sessionStorage.getItem(FILTER_STORAGE_KEY))
      const { filters, pagination: { page, pageSize }, sort } = searchCriteria
      const areFiltersApplied = JSON.stringify(filters) !== JSON.stringify(DEFAULT_FILTER_CRITERIA.filters)
      this.setState({ filters, pagination: { page, pageSize }, sort, areFiltersApplied: areFiltersApplied })
      this.fetchArticles(page, pageSize, filters, sort)
    }
  }

  fetchArticles (page = DEFAULT_PAGE, pageSize = DEFAULT_PAGE_SIZE, filters = {}, sort = {}) {
    this.setState({ loading: true })
    const url = this.getRequestUrl(page, pageSize, filters, sort)
    axios.get(url).then(res => this.handleResponse(res)).catch(() => this.setState({ loading: false }))
  }

  getRequestUrl (page, pageSize, filters, sort) {
    let url = `${endpoints.list}?page=${page}&pageSize=${pageSize}`

    Object.keys(filters).forEach((filterKey) => {
      filters[filterKey].forEach((filterValue) => {
        if (filterKey === 'search') {
          url = url.concat(`&q=${filterValue.id}`)
        } else {
          url = url.concat(`&${filterKey}[]=${filterValue.id}`)
        }
      })
    })

    if (Object.keys(sort).length > 0) url = url.concat(`&order=${sort.order}&direction=${sort.direction}`)

    return url
  }

  onPageChange (page) {
    const pageSize = this.state.pagination.pageSize
    this.fetchArticles(page, pageSize, this.state.filters)
    this.updateFilterCriteria('pagination', { page, pageSize })
  }

  onPageSizeChange (pageSize) {
    const page = DEFAULT_PAGE
    this.fetchArticles(page, pageSize, this.state.filters)
    this.updateFilterCriteria('pagination', { page, pageSize })
  }

  onFilterChange (filter, payload) {
    this.setState({
      filters: { ...this.state.filters, [filter]: payload },
      areFiltersApplied: true
    }, () => {
      const { filters, pagination: { page, pageSize } } = this.state
      this.fetchArticles(page, pageSize, filters)
      this.updateFilterCriteria('filters', filters)
    })
  }

  onSortChange (order) {
    const { direction } = this.state.sort

    if (direction === 'desc') this.updateSortCriteria(order, 'asc')
    if (direction === 'asc') this.updateSortCriteria(order, 'desc')
  }

  updateSortCriteria (order, newDirection) {
    this.setState({ sort: { order: order, direction: newDirection } }, () => {
      const { filters, pagination: { page, pageSize }, sort } = this.state
      this.fetchArticles(page, pageSize, filters, sort)
      this.updateFilterCriteria('sort', sort)
    })
  }

  updateFilterCriteria (key, value) {
    let storage = JSON.parse(window.sessionStorage.getItem(FILTER_STORAGE_KEY))
    storage[key] = value
    window.sessionStorage.setItem(FILTER_STORAGE_KEY, JSON.stringify(storage))
  }

  onClearFilterCriteria () {
    window.sessionStorage.setItem(FILTER_STORAGE_KEY, JSON.stringify(DEFAULT_FILTER_CRITERIA))
    this.setState({ filters: emptyFilters, areFiltersApplied: false })
    this.fetchArticles()
  }

  handleResponse (response) {
    const { categories, publicLabels, authors, articles, pagination } = response.data
    this.setState({
      categories: categories || [],
      labels: publicLabels || [],
      authors: authors || [],
      articles: articles || [],
      pagination: pagination,
      loading: false
    })
  }

  render ({ defaultCdn }, { categories, labels, authors, articles, filters, pagination, loading, areFiltersApplied, sort }) {
    const paginationOptions = {
      pagination,
      onPageChange: this.onPageChange,
      onPageSizeChange: this.onPageSizeChange
    }

    return (
      <ArticlesOverviewPresenter
        articles={articles}
        labels={labels}
        categories={categories}
        authors={authors}
        filters={filters}
        defaultCdn={defaultCdn}
        loading={loading}
        paginationOptions={paginationOptions}
        areFiltersApplied={areFiltersApplied}
        onFilterChange={this.onFilterChange}
        onClearFilterCriteria={this.onClearFilterCriteria}
        sort={sort}
        onSortChange={this.onSortChange}
      />
    )
  }
}

export default ArticlesOverview
